import React, {Component} from 'react'
import { connect } from 'react-redux'
import $ from 'jquery'


import BecomeXXLPopup from '../BecomeXXLPopup/index';

import Registry from '../../../registry/index';
import AnonymousLoginPopup from "../AnonymousLoginPopup";

class ChatEditorAttachmentButton extends Component {
    constructor(props) {
        super(props);

        this.onMouseHover = this.onMouseHover.bind(this);
        this.onClick = this.onClick.bind(this);
        this.onFileInputChange = this.onFileInputChange.bind(this);
        this.onAttachmentUploaded = this.onAttachmentUploaded.bind(this);
        this.onAttachmentUploadError = this.onAttachmentUploadError.bind(this);

        if (this.props.onUpload) {
            this.onUpload = this.props.onUpload;
        }
    }

    onUpload() { }

    onClick() {
        let {currentUser} = this.props;
        
        if (currentUser.isAnonymous()) {
            return false;
        } else if (!currentUser.isCertified()) {
            BecomeXXLPopup.open("attach-photo");
            return false;
        }

        this.fileInput.dispatchEvent(new MouseEvent('click', {}));
    }

    onFileInputChange() {
        let siteInterface = Registry.get('siteInterface');

        let file = this.fileInput.files[0];

        siteInterface.attachmentUpload(file)
            .then(this.onAttachmentUploaded)
            .catch(this.onAttachmentUploadError);
    }

    onAttachmentUploaded(response) {
        let lang = Registry.get('locale');

        if (response.data.status !== 'success') {
            alert(response.data.message || lang.upload_general_error);
            return false;
        }

        this.onUpload(response.data.info);

        //clear error message
        this.props.onUploadError('');
    }

    onAttachmentUploadError(error) {
        const {onUploadError} = this.props;
        onUploadError(error.message);
    }

    onMouseHover(event) {
        var button = event.target;

        if (button.className.indexOf("failed") != -1) return false;

        var offset = $(button).offset();

        var $streamingControlTooltip = $(this.tooltip);

        if (event.type == "mouseover") {
            $streamingControlTooltip.stop().css({display: "block"}).animate({opacity: 1}, 250, function() { this.style.display = "block"; });
        } else if (event.type == "mouseout") {
            $streamingControlTooltip.stop().animate({opacity: 0}, 250, function() { this.style.display = "none"; });
        }
    }

    render() {
        let lang = Registry.get('locale');

        let action = "";
        let mouseHoverProps = {onMouseOver: this.onMouseHover, onMouseOut: this.onMouseHover};

        return (
            <div className="add-attachment" onClick={this.onClick} {...mouseHoverProps}>
                <input
                    type="file"
                    name="upload"
                    accept=".png, .jpg, .jpeg"
                    ref={(fileInput) => this.fileInput = fileInput}
                    onChange={this.onFileInputChange}
                    style={{display: 'none'}}
                />
                <div  {...mouseHoverProps} className="add-attachment-control-tooltip-abs" ref={(tooltip) => this.tooltip = tooltip} dangerouslySetInnerHTML={{__html:lang.attachment_tooltip}} />

            </div>
        )
    }

}

function mapStateToProps(state, ownProps) {
    return {

        currentUser: state.currentUser
    }
}

export default ChatEditorAttachmentButton;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ChatEditorAttachmentButton/index.js